import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-6ab1d55f"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex items-center px-6 pt-6" };
var _hoisted_2 = { class: "ml-2" };
var _hoisted_3 = { class: "flex-grow ml-4 font-medium text-right truncate pr-7 lg:pr-0" };
var _hoisted_4 = { class: "flex items-center py-0 px-5 -mx-1 mt-5 space-x-2" };
var _hoisted_5 = { class: "chats" };
var _hoisted_6 = {
    key: 0,
    class: "px-7 pt-10 text-gray-400"
};
var _hoisted_7 = { key: 0 };
var _hoisted_8 = { key: 1 };
var _hoisted_9 = { key: 2 };
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
import ChatLink from './components/ChatLink.vue';
import { dynamicSort } from '@common/utils/Helpers/Helpers';
import { computed, getCurrentInstance, ref, watch } from 'vue';
import { ChatStore } from '@common/stores';
import EInput from '@common/ui/EInput.vue';
import ESelect from '@common/ui/ESelect/ESelect.vue';
import EScrollbar from '@common/ui/EScrollbar.vue';
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CourseChats',
    setup: function (__props) {
        var t = useI18n().t;
        var search = ref('');
        var sort = ref('lastmessage');
        var filter = ref([]);
        var filterValues = [
            {
                value: 'group',
                label: t('chats.groupChats'),
            },
            {
                value: 'channel',
                label: t('chats.channels'),
            },
        ];
        var sortValues = [
            {
                value: 'lastmessage',
                label: t('chats.sortByLastMessage'),
            },
            {
                value: 'name',
                label: t('chats.sortByName'),
            },
        ];
        var course = computed(function () { return ChatStore.course; });
        var chats = computed(function () { return ChatStore.chats; });
        var schoolSection = computed(function () { return ChatStore.schoolSection; });
        var currentChat = computed(function () { return ChatStore.contentChat; });
        var courseChats = computed(function () {
            if (!course.value || !chats.value)
                return [];
            var chatsLocal = chats.value.filter(function (chat) {
                return chat.course && chat.course.id === course.value.id;
            });
            chatsLocal = chatsLocal.filter(function (chat) {
                if (filter.value.length === 0)
                    return true;
                if (chat.type === 'group' && filter.value.includes('group')) {
                    return true;
                }
                else if (chat.type === 'channel' && filter.value.includes('channel')) {
                    return true;
                }
            });
            if (search.value.length > 0) {
                var searchString_1 = search.value.toLowerCase();
                chatsLocal = chatsLocal.filter(function (chat) {
                    return chat.type === 'dialogue' ? chat.recipient.email.toLowerCase().includes(searchString_1)
                        || chat.recipient.name.toLowerCase().includes(searchString_1) : chat.name.toLowerCase().includes(searchString_1);
                });
            }
            chatsLocal = sort.value === 'name' ? chatsLocal.sort(dynamicSort('name')) : chatsLocal.sort(function (a, b) {
                if (!a.lastMessage) {
                    return 1;
                }
                else if (!b.lastMessage) {
                    return -1;
                }
                if (a.lastMessage.createdAt === b.lastMessage.createdAt) {
                    return 0;
                }
                return a.lastMessage.createdAt < b.lastMessage.createdAt ? 1 : -1;
            });
            return chatsLocal;
        });
        watch(chats, function () {
            var _a, _b;
            (_b = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy) === null || _b === void 0 ? void 0 : _b.$forceUpdate();
        });
        var hideCourse = function () {
            ChatStore.schoolSection = 'common';
        };
        var goSettings = function () {
            ChatStore.openSettingsPage();
        };
        var openChat = function (chat) {
            ChatStore.openChatPage(chat);
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{
                        'course-chats--hidden': schoolSection.value !== 'course'
                    }, "flex overflow-x-hidden absolute top-0 left-0 z-20 flex-col flex-grow w-full h-full max-h-full bg-gray-50 transition-all duration-200 course-chats"])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "flex shrink-0 items-center py-2 font-medium text-gray-400 transition-colors cursor-pointer hover:text-primary-300",
                        onClick: hideCourse
                    }, [
                        _createVNode(_component_e_icon, {
                            class: "mr-1 w-2 h-4",
                            icon: "angle-left"
                        }),
                        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('chats.allChats')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(course.value.name), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(EInput, {
                        modelValue: search.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((search).value = $event); }),
                        placeholder: _unref(t)('chats.search'),
                        theme: "gray"
                    }, {
                        prepend: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "w-4 h-4 text-gray-400",
                                icon: "search"
                            })
                        ]; }),
                        _: 1
                    }, 8, ["modelValue", "placeholder"]),
                    _createVNode(ESelect, {
                        modelValue: filter.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((filter).value = $event); }),
                        options: filterValues,
                        theme: "gray",
                        "dynamic-overlay-width": "",
                        "empty-content": "",
                        multiple: ""
                    }, {
                        prepend: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: _normalizeClass([[
                                        filter.value.length > 0 && 'text-red'
                                    ], "w-3 h-3 text-gray-300"]),
                                icon: "filter"
                            }, null, 8, ["class"])
                        ]; }),
                        _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(ESelect, {
                        modelValue: sort.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((sort).value = $event); }),
                        options: sortValues,
                        theme: "gray",
                        "dynamic-overlay-width": "",
                        "empty-content": ""
                    }, {
                        prepend: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: _normalizeClass([[
                                        sort.value === 'name' && 'text-red'
                                    ], "w-3 h-3 text-gray-300"]),
                                icon: "direction"
                            }, null, 8, ["class"])
                        ]; }),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _createVNode(EScrollbar, {
                    options: { suppressScrollX: true },
                    class: "mt-4"
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_5, [
                            (courseChats.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (filter.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)('chats.noChatsByFilters')), 1))
                                        : (search.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)('chats.noChatsWithSearch', { search: search.value })), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                                _createTextVNode(_toDisplayString(_unref(t)('chats.noChats')) + " ", 1),
                                                _hoisted_10,
                                                _createTextVNode(" " + _toDisplayString(_unref(t)('chats.noChatsText')), 1)
                                            ]))
                                ]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseChats.value, function (chat) {
                                var _a;
                                return (_openBlock(), _createBlock(ChatLink, {
                                    active: currentChat.value.id === chat.id,
                                    avatar: chat.avatar,
                                    "is-audio": !!((_a = chat.lastMessage) === null || _a === void 0 ? void 0 : _a.audio),
                                    "last-message-file-type": chat.lastMessage ? chat.lastMessage.fileType : '',
                                    "last-message-text": chat.lastMessage ? chat.lastMessage.text : '',
                                    "last-message-time": chat.lastMessage ? chat.lastMessage.createdAt : 0,
                                    name: chat.name,
                                    type: chat.type,
                                    "unread-messages-count": chat.unreadMessages,
                                    onClick: function ($event) { return (openChat(chat)); }
                                }, null, 8, ["active", "avatar", "is-audio", "last-message-file-type", "last-message-text", "last-message-time", "name", "type", "unread-messages-count", "onClick"]));
                            }), 256))
                        ])
                    ]; }),
                    _: 1
                })
            ], 2));
        };
    }
});
